module.exports = __webpack_public_path__ + "static/media/illustration-megaphone-exclamation.697374ae.svg";